import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

import AuthSlice from "./Auth/AuthSlice";
import userSlice from "./UserSlice/userSlice";
import signInSlice from "./SignIn/signInSlice";
import SignupSlice from "./Signup/SignupSlice";
import assignOrderSlice from "./AssignOrder/AssignOrderSlice";
import usersSlice from "./Users/usersSlice";
const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, AuthSlice);

export const store = configureStore({
  reducer: {
    authentication: persistedReducer,
    user: userSlice,
    users: usersSlice,
    signIn: signInSlice,
    signup: SignupSlice,
    assignOrder: assignOrderSlice,
  },
  middleware: [thunk],
});

export const persistor = persistStore(store);
